import { Action } from '@ngrx/store';

export enum AuthActionTypes {
  INIT_AUTHENTICATION = '[Cyclops Auth] Init Authentication',
  INIT_USER_REGISTRATION = '[Cyclops Auth] Init User Registration',
  SEND_OTP = '[Cyclops Auth] Send OTP',
  SEND_OTP_SUCCESS = '[Cyclops Auth] Send OTP Success',
  SEND_OTP_FAILURE = '[Cyclops Auth] Send OTP Failure',
  ORG_CREATE = '[Cyclops Auth] Orgnization Create',
  ORG_CREATE_SUCCESS = '[Cyclops Auth] Orgnization Create Success',
  ORG_CREATE_FAILURE = '[Cyclops Auth] Orgnization Create Failure',
  USER_LOGIN_TYPE = '[Cyclops Auth] User Login Type',
  USER_LOGIN = '[Cyclops Auth] User Login',
  USER_LOGIN_SUCCESS = '[Cyclops Auth] User Login Success',
  USER_LOGIN_FAILURE = '[Cyclops Auth] User Login Failure',
  OTP_USER_LOGIN = '[Cyclops Auth] OTP User Login',
  OTP_USER_LOGIN_SUCCESS = '[Cyclops Auth] OTP User Login Success',
  OTP_USER_LOGIN_FAILURE = '[Cyclops Auth] OTP User Login Failure',

  SELECTED_ORG_LOGIN = '[Cyclops Auth] Selected Org Login',
  SELECTED_ORG_LOGIN_SUCCESS = '[Cyclops Auth] Selected Org Login Success',
  SELECTED_ORG_LOGIN_FAILURE = '[Cyclops Auth] Selected Org Login Failure',

  GET_ORGANIZATIONS = '[Cyclops Auth] Get Organizations',
  GET_ORGANIZATIONS_SUCCESS = '[Cyclops Auth] Get Organizations Success',
  GET_ORGANIZATIONS_FAILURE = '[Cyclops Auth] Get Organizations Failure',
  CHECK_VALID_LOGIN = '[Cyclops Auth] Check Valid Login',
  CHECK_VALID_LOGIN_SUCCESS = '[Cyclops Auth] Check Valid Login Success',
  CHECK_VALID_LOGIN_FAILURE = '[Cyclops Auth] Check Valid Login Failure',
  SEND_LOGIN_OTP = '[Cyclops Auth] Send Login OTP',
  SEND_LOGIN_OTP_SUCCESS = '[Cyclops Auth] Send Login OTP Success',
  SEND_LOGIN_OTP_FAILURE = '[Cyclops Auth] Send Login OTP Failure',
  FIREBASE_SIGN_IN_REQUEST = '[Cyclops Auth] Firebase Sign In Request',
  FIREBASE_SIGN_IN_SUCCESS = '[Cyclops Auth] Firebase Sign In Success',
  FIREBASE_SIGN_IN_FAILURE = '[Cyclops Auth] Firebase Sign In Failure',

  REDIRECTING_TO_DASHBOARD = '[Cyclops Auth]  Redirecting To Dashboard',
  REDIRECTING_TO_LOGIN = '[Cyclops Auth]  Redirecting To Login',
  SET_CONTEXT_DATA = '[Cyclops Auth] Set Context Data',
  RESET_STATE = '[Cyclops Auth] Reset State',
  RESET_LOGIN_FORM_STATE = '[Cyclops Auth] Reset Login Form State',
}
export class ResetState implements Action {
  readonly type = AuthActionTypes.RESET_STATE;
  constructor(public payload: any) {}
}
export class ResetLoginFormState implements Action {
  readonly type = AuthActionTypes.RESET_LOGIN_FORM_STATE;
  constructor(public payload: any) {}
}
export class InitAuthentication implements Action {
  readonly type = AuthActionTypes.INIT_AUTHENTICATION;
  constructor(public payload: any) {}
}
export class InitUserRegistration implements Action {
  readonly type = AuthActionTypes.INIT_USER_REGISTRATION;
  constructor(public payload: any) {}
}
export class UserLoginType implements Action {
  readonly type = AuthActionTypes.USER_LOGIN_TYPE;
  constructor(public payload: any) {}
}
export class UserLogin implements Action {
  readonly type = AuthActionTypes.USER_LOGIN;
  constructor(public payload: any) {}
}
export class UserLoginSuccess implements Action {
  readonly type = AuthActionTypes.USER_LOGIN_SUCCESS;
  constructor(public payload: any) {}
}
export class UserLoginFailure implements Action {
  readonly type = AuthActionTypes.USER_LOGIN_FAILURE;
  constructor(public payload: any) {}
}
export class OtpUserLogin implements Action {
  readonly type = AuthActionTypes.OTP_USER_LOGIN;
  constructor(public payload: any) {}
}
export class OtpUserLoginSuccess implements Action {
  readonly type = AuthActionTypes.OTP_USER_LOGIN_SUCCESS;
  constructor(public payload: any) {}
}
export class OtpUserLoginFailure implements Action {
  readonly type = AuthActionTypes.OTP_USER_LOGIN_FAILURE;
  constructor(public payload: any) {}
}
export class SelectedOrgLogin implements Action {
  readonly type = AuthActionTypes.SELECTED_ORG_LOGIN;
  constructor(public payload: any) {}
}
export class SelectedOrgLoginSuccess implements Action {
  readonly type = AuthActionTypes.SELECTED_ORG_LOGIN_SUCCESS;
  constructor(public payload: any) {}
}
export class SelectedOrgLoginFailure implements Action {
  readonly type = AuthActionTypes.SELECTED_ORG_LOGIN_FAILURE;
  constructor(public payload: any) {}
}
export class SendLoginOtp implements Action {
  readonly type = AuthActionTypes.SEND_LOGIN_OTP;
  constructor(public payload: any) {}
}
export class SendLoginOtpSuccess implements Action {
  readonly type = AuthActionTypes.SEND_LOGIN_OTP_SUCCESS;
  constructor(public payload: any) {}
}
export class SendLoginOtpFailure implements Action {
  readonly type = AuthActionTypes.SEND_LOGIN_OTP_FAILURE;
  constructor(public payload: any) {}
}
export class GetOrganizations implements Action {
  readonly type = AuthActionTypes.GET_ORGANIZATIONS;
  constructor(public payload: any) {}
}
export class GetOrganizationsSuccess implements Action {
  readonly type = AuthActionTypes.GET_ORGANIZATIONS_SUCCESS;
  constructor(public payload: any) {}
}
export class GetOrganizationsFailure implements Action {
  readonly type = AuthActionTypes.GET_ORGANIZATIONS_FAILURE;
  constructor(public payload: any) {}
}
export class OrganizationCreate implements Action {
  readonly type = AuthActionTypes.ORG_CREATE;
  constructor(public payload: any) {}
}
export class OrganizationCreateSuccess implements Action {
  readonly type = AuthActionTypes.ORG_CREATE_SUCCESS;
  constructor(public payload: any) {}
}
export class OrganizationCreateFailure implements Action {
  readonly type = AuthActionTypes.ORG_CREATE_FAILURE;
  constructor(public payload: any) {}
}
export class SendOTP implements Action {
  readonly type = AuthActionTypes.SEND_OTP;
  constructor(public payload: any) {}
}
export class SendOTPSuccess implements Action {
  readonly type = AuthActionTypes.SEND_OTP_SUCCESS;
  constructor(public payload: any) {}
}
export class SendOTPFailure implements Action {
  readonly type = AuthActionTypes.SEND_OTP_FAILURE;
  constructor(public payload: any) {}
}
export class CheckValidLogin implements Action {
  readonly type = AuthActionTypes.CHECK_VALID_LOGIN;
  constructor(public payload: any) {}
}
export class CheckValidLoginSuccess implements Action {
  readonly type = AuthActionTypes.CHECK_VALID_LOGIN_SUCCESS;
  constructor(public payload: any) {}
}
export class CheckValidLoginFailure implements Action {
  readonly type = AuthActionTypes.CHECK_VALID_LOGIN_FAILURE;
  constructor(public payload: any) {}
}
export class RedirectingToDashboard implements Action {
  readonly type = AuthActionTypes.REDIRECTING_TO_DASHBOARD;
  constructor(public payload: any) {}
}
export class RedirectingToLogin implements Action {
  readonly type = AuthActionTypes.REDIRECTING_TO_LOGIN;
  constructor(public payload: any) {}
}
export class SetContextData implements Action {
  readonly type = AuthActionTypes.SET_CONTEXT_DATA;
  constructor(public payload: any) {}
}
export class FirebaseSignInRequest implements Action {
  readonly type = AuthActionTypes.FIREBASE_SIGN_IN_REQUEST;
  constructor(public payload?: any) {}
}

export class FirebaseSignInSuccess implements Action {
  readonly type = AuthActionTypes.FIREBASE_SIGN_IN_SUCCESS;
  constructor(public payload?: any) {}
}

export class FirebaseSignInFailure implements Action {
  readonly type = AuthActionTypes.FIREBASE_SIGN_IN_FAILURE;
  constructor(public payload: any) {}
}

export type CyclopsAuthActionUnion =
  | ResetState
  | ResetLoginFormState
  | UserLoginType
  | UserLogin
  | UserLoginSuccess
  | UserLoginFailure
  | OrganizationCreate
  | OrganizationCreateSuccess
  | OrganizationCreateFailure
  | SendOTP
  | SendOTPSuccess
  | SendOTPFailure
  | InitAuthentication
  | InitUserRegistration
  | SetContextData
  | RedirectingToLogin
  | GetOrganizations
  | GetOrganizationsSuccess
  | GetOrganizationsFailure
  | CheckValidLogin
  | CheckValidLoginSuccess
  | CheckValidLoginFailure
  | SendLoginOtp
  | SendLoginOtpSuccess
  | SendLoginOtpFailure
  | OtpUserLogin
  | OtpUserLoginSuccess
  | OtpUserLoginFailure
  | SelectedOrgLogin
  | SelectedOrgLoginSuccess
  | SelectedOrgLoginFailure
  | FirebaseSignInRequest
  | FirebaseSignInFailure
  | FirebaseSignInSuccess;
